// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1qXVJ","modalFooterButton":"ModalNotes_modalFooterButton__3ufsU"};